export interface CorrectionLetterKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the Correction Letter modal read. Keyed on
 * approvalId alone, since the BFF endpoint is
 * `/api/v1/workbench/applications/{approvalId}/correction-letter`.
 */
export const correctionLetterKeys = {
  all: ["correctionLetter"] as const,
  details: () => [...correctionLetterKeys.all, "detail"] as const,
  detail: (arguments_: CorrectionLetterKeyArguments) => [...correctionLetterKeys.details(), arguments_] as const,
};
